var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { get, trim } from 'lodash';
import { classNames } from '../../utils/cn';
import { MenuItemLink } from './menu-item-link';
import { useEntity } from '../../hooks/use-entity';
import { useActiveEntity } from '../../hooks/use-active-entity';
import { useComponentColor } from '../../hooks/use-component-color';
var cls = classNames('site-footer-navigation');
export var SiteFooterNavigationDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    display: flex;\n    font-size: 1em;\n    flex-direction: column;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  "], ["\n    width: 100%;\n    display: flex;\n    font-size: 1em;\n    flex-direction: column;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  "]))),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: 0;\n    width: auto;\n    flex-direction: row;\n  "], ["\n    margin-top: 0;\n    width: auto;\n    flex-direction: row;\n  "])))
});
var NavigationItemStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n    width: 100%;\n\n  "], ["\n    border-bottom: 1px solid ", ";\n    width: 100%;\n\n  "])), theme.COLOR('line-subtle')),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    border-bottom: none;\n  "], ["\n    border-bottom: none;\n  "])))
});
var MenuItemLinkStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-weight: 600;\n    font-size: 1em;\n    padding: ", " 0;\n  "], ["\n    font-weight: 600;\n    font-size: 1em;\n    padding: ", " 0;\n  "])), theme.UNIT(2)),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: 1em;\n    padding: ", " ", ";\n  "], ["\n    font-size: 1em;\n    padding: ", " ", ";\n  "])), theme.UNIT(2), theme.UNIT(3))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  NavigationItem: styled.li.attrs(cls.attr('navigation-item'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), NavigationItemStyles),
  MenuItemLink: styled(MenuItemLink)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), MenuItemLinkStyles)
};
export var SiteFooterNavigation = function SiteFooterNavigation(props) {
  var _a;

  var className = props.className,
      children = props.children;
  var entity = useEntity(props.entity);
  var currentEntity = useActiveEntity();

  if (!((_a = entity === null || entity === void 0 ? void 0 : entity.items) === null || _a === void 0 ? void 0 : _a.length)) {
    return null;
  }

  var menuItemColor = useComponentColor({
    cls: cls,
    prop: props.menuItemLinkColor,
    sub: 'menu-item-link',
    fallbacks: ['dark'],
    invertedFallbacks: ['light']
  });
  var menuItemActiveColor = useComponentColor({
    cls: cls,
    prop: props.menuItemLinkActiveColor,
    sub: 'menu-item-link-active',
    fallbacks: ['link-active', 'link', 'mid-brand', 'primary'],
    invertedFallbacks: ['inverted-link-active', 'mid-brand', 'primary', 'light']
  });
  var menuItemLinkHoverColor = useComponentColor({
    cls: cls,
    prop: props.menuItemLinkHoverColor,
    sub: 'menu-item-link-hover',
    fallbacks: ['link-hover', 'mid-brand', 'primary'],
    invertedFallbacks: ['inverted-link-hover', 'mid-brand', 'primary']
  });
  return React.createElement(My.Container, null, entity.items.map(function (item) {
    var path = trim(get(item, 'page.path', item.path));

    if (path === '') {
      // don't display items without paths. This can include items that have children but don't have a path themselves.
      return null;
    }

    var isActive = path !== '' && trim(currentEntity === null || currentEntity === void 0 ? void 0 : currentEntity.path, '/') === trim(path, '/');
    return React.createElement(My.NavigationItem, {
      key: item.id
    }, React.createElement(My.MenuItemLink, {
      variant: 'footer',
      isActive: isActive,
      color: menuItemColor,
      activeColor: menuItemActiveColor,
      hoverColor: menuItemLinkHoverColor,
      entity: item
    }));
  }));
};
SiteFooterNavigation.defaultProps = SiteFooterNavigationDefaultProps;
SiteFooterNavigation.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;